import { useMutation } from '@tanstack/react-query';

import { deleteReferral } from 'lib/api/community';
import { errorHandler } from 'utils/errors';

function useLeaveCommunity() {
  const mutation = useMutation({
    mutationFn: async () => {
      try {
        const response = await deleteReferral();

        if (!response.data) {
          throw new Error(
            'Something is terribly wrong, please contact our administrator',
          );
        }

        const { data } = response;

        return data.message;
      } catch (error) {
        errorHandler(error, 'Failed to leave community, unhandled error');
        return undefined;
      }
    },
    retry: false,
  });

  return mutation;
}

export default useLeaveCommunity;
